"use client";
import { j as s } from "./jsx-runtime-CJ-St4mQ.mjs";
import { c as w, w as E } from "./capitalize-wVM0qIkw.mjs";
import { r as T, l as g, f as z, a as x, c as B, e as N, h as R } from "./Field.style-CQ8CRW6E.mjs";
import { F as S, a as j, b as q } from "./FieldDescription-LT07Zs4i.mjs";
import { F as D } from "./FieldLabel-C2NVcnds.mjs";
import { F as L } from "./FieldControl-CwYVSJ2g.mjs";
const I = (n) => {
  const {
    helpText: c,
    label: d,
    name: m,
    type: f,
    required: p,
    placeholder: F,
    startAdornment: a,
    endAdornment: l,
    error: r,
    className: v,
    colSpan: C,
    value: u,
    invalid: y,
    inputProps: e,
    wrapperclassName: b,
    ...A
  } = n, o = a !== void 0, t = l !== void 0, h = n.type === "file", i = w(E(m).join(" "));
  return /* @__PURE__ */ s.jsxs(
    S,
    {
      invalid: !!r || y,
      name: m,
      ...A,
      className: T({ colSpan: C, className: v }),
      validationMode: h ? "onBlur" : "onChange",
      children: [
        (d || i) && /* @__PURE__ */ s.jsx(D, { className: g({ required: p }), children: d || i }),
        /* @__PURE__ */ s.jsxs("div", { className: z({ class: b }), children: [
          a && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: x({
                hasStartAdornment: o,
                hasEndAdornment: t
              }),
              children: a
            }
          ),
          /* @__PURE__ */ s.jsx(
            L,
            {
              required: p,
              type: f || "text",
              value: u,
              placeholder: F || `Please enter your ${i}`,
              ...e,
              className: B({
                hasStartAdornment: o,
                hasEndAdornment: t,
                isFile: h,
                class: typeof (e == null ? void 0 : e.className) == "string" ? e == null ? void 0 : e.className : ""
              })
            }
          ),
          l && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: x({
                hasStartAdornment: o,
                hasEndAdornment: t
              }),
              children: l
            }
          )
        ] }),
        r ? /* @__PURE__ */ s.jsx(j, { className: N({}), match: !0, children: r }) : /* @__PURE__ */ s.jsx(j, { className: N({}) }),
        c && /* @__PURE__ */ s.jsx(q, { className: R({}), children: c })
      ]
    }
  );
};
export {
  I as default
};
